import i18n from 'i18next';
import { z } from 'zod/v3';

export const loginFormSchema = z.object({
	email: z.string().min(1, i18n.t('validation_email_required')).email(i18n.t('validation_email_invalid')),
	password: z.string().min(1, i18n.t('validation_password_required')),
});

export type LoginFormValues = z.infer<typeof loginFormSchema>;

export const emptyLoginFormValues: LoginFormValues = {
	email: '',
	password: '',
};
